module.exports = __webpack_public_path__ + "media/music/c44ce3bfa465281e765f197d6c3ee7ea.mp3";